/* 🤖 this file was generated by svg-to-ts */
export const matIconReceipt: {
  name: 'receipt';
  data: string;
} = {
  name: 'receipt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19.5 3.5 18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5zM19 19.09H5V4.91h14v14.18zM6 15h12v2H6zm0-4h12v2H6zm0-4h12v2H6z"/></svg>`
};
